"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0; // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//
// Inspired by: https://stackoverflow.com/a/39077686/1783174
//

var hex2rgba = function hex2rgba(hex) {
  var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var rgbArray = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (m, r, g, b) {
    return '#' + r + r + g + g + b + b;
  }).substring(1).match(/.{2}/g).map(function (x) {
    return parseInt(x, 16);
  });
  return "rgba(".concat(rgbArray.join(','), ",").concat(a, ")");
};

var _default = hex2rgba;
exports["default"] = _default;